import DocImg from "../../../../src/components/docs/doc-img";
import managePrices from "../../../../src/assets/docs/dashboard/manage/linkfive-global-subscription-prices.png";
import * as React from 'react';
export default {
  DocImg,
  managePrices,
  React
};